import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "shards-react";

import PageTitle from "../components/common/PageTitle";
import AreaView from "./AreaView";
import AreaDetails from "./AreaDetails";
import { Store } from "../flux";
import AreaAPIDetails from "./AreaAPIDetails";

const AreaDetailsView = props => {

    const [ Area, SetArea ] = useState({});
    const [ Apps, SetApps ] = useState({});
    const [ Ready, SetReady ] = useState(false);
    const [ ShowAlert, SetShowAlert ] = useState(false);

    console.log(Area);

    useEffect(() => {

        const setData = async () => {

            await SetArea(props.location.state.AreaDetails);
            await SetApps(props.location.state.Apps);
            SetReady(true);
        }

        setData();
    }, [ props.location.state.AreaDetails, props.location.state.Apps ]);

    const handleChange = async (Value, Field) => {

        SetArea({ ...Area, [Field]: Value });
    }

    const handleAPIChange = async (Value, Field, APIIndex) => {

        let TempAPIDetails = Area.api_details;
        TempAPIDetails[APIIndex][Field] = Value;

        SetArea({ ...Area, api_details: TempAPIDetails });
    }

    const addApp = async (APIDetail) => {

        if (Area.api_details !== false) {

            SetArea({ ...Area, api_details: [ ...Area.api_details, APIDetail ] });
        } else {

            SetArea({ ...Area, api_details: [ APIDetail ] });
        }
    }

    const removeApp = async (APIDetailIndex) => {

        SetArea({ ...Area, api_details: Area.api_details.filter((api, index) => index !== APIDetailIndex) });
    }

	return (
		<Container fluid className="main-content-container px-4">
			<Row noGutters className="page-header py-4">
                <Col className="col-12">
				    <PageTitle title="Edit" subtitle="Area" md="12" className="ml-sm-auto mr-sm-auto" />
                </Col>
			</Row>
			<Row>
				<Col lg="4">
					{ Ready && <AreaView Area={ Area } Apps={ Apps } /> }
				</Col>
				<Col lg="8">
					{ Ready && <AreaDetails Area={ Area } Apps={ Apps } Change={ handleChange } /> }
				</Col>
			</Row>

            <Row>
                <Col lg="12">
                    { Ready && <AreaAPIDetails Area={ Area } Apps={ Apps } Change={ handleAPIChange } AddApp={ addApp } RemoveApp={ removeApp } /> }
                </Col>
            </Row>
		</Container>
	);
}

export default AreaDetailsView;
